import { useObservableState } from 'observable-hooks';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import Form from '../../../components/form';
import Checkbox from '../../../components/form/elements/checkbox';
import Group from '../../../components/form/elements/group';
import Link from '../../../components/form/elements/link';
import Readonly from '../../../components/form/elements/readonly';
import Text from '../../../components/form/elements/text';
import TextArea from '../../../components/form/elements/text-area';
import Warehouse from '../../../interfaces/warehouse';
import {
  WAREHOUSE_WAREHOUSES_EDIT,
  WAREHOUSE_WAREHOUSES_INDEX,
} from '../../../router/routes';
import { useService } from '../../../services/services';
import { can, route } from '../../../services/utils';
import { RootState } from '../../../store/store';

export default function WarehouseView() {
  const { farmId, id } = useParams<{ farmId: string; id: string }>();
  const { t } = useTranslation();
  const { warehouseService } = useService();
  const [bodyElements, setBodyElements] = useState([]);
  const [footerElements, setFooterElements] = useState([]);
  const [warehouse] = useObservableState<Warehouse>(
    () => warehouseService.show(farmId, id),
    null
  );
  const { farmUser } = useSelector((state: RootState) => ({
    farmUser: state.global.farmUser,
  }));

  useEffect(() => {
    if (warehouse !== null) {
      setBodyElements([
        Readonly([
          Group([
            Text('name', t('pages.warehouse.warehouses.name')),
            Text(
              'type_of_warehouse_value',
              t('pages.warehouse.warehouses.type')
            ),
            Text('address', t('pages.warehouse.warehouses.address')),
            Text('coordinates', t('pages.warehouse.warehouses.coordinates')),
            Text(
              'department_pvd_nr',
              t('pages.warehouse.warehouses.department_pvd_nr')
            ),
            Checkbox('active', t('pages.warehouse.warehouses.active')),
            TextArea('comment', t('pages.warehouse.warehouses.comment')),
          ]),
        ]),
      ]);

      setFooterElements(() => {
        let elements = [];

        if (can(farmUser, { title: 'update warehouse' })) {
          elements.push(
            Link(route(WAREHOUSE_WAREHOUSES_EDIT, { farmId, id }), 'edit', true)
          );
        }

        return elements;
      });
    }
  }, [
    farmUser,
    warehouse,
    farmId,
    id,
    warehouseService,
    t,
    setBodyElements,
    setFooterElements,
  ]);

  const formTitle = warehouse
    ? warehouse.name
    : t('pages.warehouse.warehouses.view-warehouse');

  return (
    <Form
      mode={'view'}
      title={formTitle}
      backTo={route(WAREHOUSE_WAREHOUSES_INDEX, { farmId })}
      body={bodyElements}
      footer={footerElements}
      values={warehouse}
    />
  );
}
